import services from "@/services/index.js";

export default {
    partnersValidateToken: async (token) => {
        return await services.postAsync({
            url: `/partners/tokens`,
            headers: { token },
            body: null,
            hasToken: false
        });
    },
}